import Onview from '@tencent/vft-onview';

const _genKey = (function () {
    let index = 0;
    return function () {
        return '' + (index++);
    }
})();

function removeHttp(src){
    if(!src) return src;

    if(typeof src === 'object' && src.backgroundImage){
        src.backgroundImage = src.backgroundImage.replace(/^http:/,'')
        return src;
    }

    if(typeof src === 'string'){
        return src.replace(/^http:/,'')
    }

    return src;
}

export default {
    install(Vue) {

        function setImage(el){
            if(el.tagName.toLowerCase()==='img'){
                $(el).attr('src',$(el).data('img-url'))
            }else {
                $(el).css('background-image', 'url(' + $(el).data('img-url') + ')');
            }
        }

        let unBindExpose = [];

        function bind(el,binding) {
            let key = _genKey();
            $(el).data('img-key', key);
            $(el).data('img-url', removeHttp(binding.value));
            Vue.nextTick(() => {
                unBindExpose[key] = Onview(el, {
                    once: true,
                    offsetTop:-300,
                    offsetLeft:-300,
                }, setImage.bind(null,el));
            })
        }

        function unbind(el) {
            let key = $(el).data('img-key');
            unBindExpose[key] && unBindExpose[key]();
            delete unBindExpose[key];
        }

        Vue.directive('img', {
            bind,
            update: function (el,binding) {
                unbind(el);
                bind(el,binding);
            },
            unbind,
        })

    }
}